<template>
    <div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "accordionType",
        data() {
            return {
                tabs: []
            }
        },
        methods: {
            addTab($this) {
                this.tabs.push($this.title)
            }
        },
    }
</script>

<style scoped>

</style>